module.exports = __webpack_public_path__ + "img/mobile_btn2.9f3ae251.png";